import { environment } from '../environments/environment';

export const SERVER_API_URL = environment.API_URL;

export class AppConfig {
  public static LOGIN_API = environment.API_URL.concat('authenticate');
  public static SIGN_UP_API = environment.API_URL.concat('register');
  public static ACTIVATE_USER_API = environment.API_URL.concat('activate');
  public static ACCOUNT_API = environment.API_URL.concat('account');
  public static CHANGE_PASSWORD_API = environment.API_URL.concat('account/change-password');
  public static RESET_PASSWORD_INIT_API = environment.API_URL.concat('account/reset-password/init');
  public static RESET_PASSWORD_FINISH_API = environment.API_URL.concat('account/reset-password/finish');
  public static CUSTOMERS = environment.API_URL.concat('customers');
  public static DEVICES = environment.API_URL.concat('devices');
  public static DEVICE = environment.API_URL.concat('device/');
  public static STATUS = AppConfig.DEVICE.concat('status');
  public static SOCKET_STATUS = AppConfig.DEVICE.concat('socket/status');
  public static FINALIZE_CONFIGS = AppConfig.DEVICE.concat('save-configuration');
  public static GET_CONFIGS = AppConfig.DEVICE.concat('get-configuration');
  public static UPDATE_CONFIGS = AppConfig.DEVICE.concat('update-configuration');
  public static DEVICE_TILT = AppConfig.DEVICE.concat('tilt');
  public static CUSTOMER_CHANGE_STATUS = environment.API_URL.concat('customers/change-status');
  public static USERS = environment.API_URL.concat('users');
  public static DEVICE_ALIGN = environment.API_URL.concat('device-alignment');
  public static AUTO_SELECT_QUADRANT = AppConfig.DEVICE.concat('auto-select-quadrant');
  public static FIRMWARE = 'firmware/';
  public static DEVICE_LOGS = environment.API_URL.concat('event-logs');
  public static FIRMWARES = AppConfig.DEVICE.concat('firmwares');
  public static UPDATE_FIRMWARE_INFO = AppConfig.DEVICE.concat('update-firmware-info');
  public static FIRMWARE_CHECK_STATUS = AppConfig.FIRMWARE.concat('check-status/');

  /****************************************
   * Frontend URLs
   ***************************************/
  public static _LOGIN = '/login';
  public static _REGISTER = '/register';
  public static _ADMIN = '/admin/';
  public static _ADMIN_CUSTOMER = AppConfig._ADMIN.concat('customer');
  public static _ADMIN_DEVICE_FIRMWARE = AppConfig._ADMIN.concat('device-firmware');
  public static _ADMIN_DEVICE_LOGS = AppConfig._ADMIN.concat('device-logs');

  public static _CUSTOMER = '/customer/';
  public static _CUSTOMER_DASHBOARD = AppConfig._CUSTOMER.concat('dashboard');

  public static DEVICE_COMMAND = environment.API_URL.concat('device/test-command');
}
